var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C11.8132 -1.95685e-08 13.1136 0.258658 14.3268 0.761205C15.5401 1.26375 16.6425 2.00035 17.5711 2.92893C18.4997 3.85752 19.2362 4.95991 19.7388 6.17317C20.2413 7.38642 20.5 8.68678 20.5 10C20.5 11.3132 20.2413 12.6136 19.7388 13.8268C19.2362 15.0401 18.4997 16.1425 17.5711 17.0711C16.6425 17.9997 15.5401 18.7362 14.3268 19.2388C13.1136 19.7413 11.8132 20 10.5 20C7.84784 20 5.3043 18.9464 3.42893 17.0711C1.55357 15.1957 0.5 12.6522 0.5 10C0.5 7.34784 1.55357 4.8043 3.42893 2.92893C5.3043 1.05357 7.84784 3.95203e-08 10.5 0ZM10.5 13.3333C10.1685 13.3333 9.85054 13.465 9.61612 13.6995C9.3817 13.9339 9.25 14.2518 9.25 14.5833C9.25 14.9149 9.3817 15.2328 9.61612 15.4672C9.85054 15.7016 10.1685 15.8333 10.5 15.8333C10.8315 15.8333 11.1495 15.7016 11.3839 15.4672C11.6183 15.2328 11.75 14.9149 11.75 14.5833C11.75 14.2518 11.6183 13.9339 11.3839 13.6995C11.1495 13.465 10.8315 13.3333 10.5 13.3333ZM10.5 4.16667C10.305 4.1666 10.1161 4.23495 9.96624 4.35982C9.8164 4.48468 9.71511 4.65814 9.68 4.85L9.66667 5V10.8333L9.68 10.9833C9.71479 11.1755 9.81594 11.3493 9.96581 11.4745C10.1157 11.5996 10.3047 11.6682 10.5 11.6682C10.6953 11.6682 10.8843 11.5996 11.0342 11.4745C11.1841 11.3493 11.2852 11.1755 11.32 10.9833L11.3333 10.8333V5L11.32 4.85C11.2849 4.65814 11.1836 4.48468 11.0338 4.35982C10.8839 4.23495 10.695 4.1666 10.5 4.16667Z",
    fill: "url(#paint0_linear_24723_23371)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_24723_23371",
    x1: 0.5,
    y1: 10,
    x2: 20.5,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31C5E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.953d1c06124d39aa1a75ca687d7275e2.svg";
export { ForwardRef as ReactComponent };